import React from 'react';
import { GetColumns, SummaryTableList } from './SumarryTableColumnInfo';
import { MaterialReactTable, MRT_Row, useMaterialReactTable } from 'material-react-table';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import { Box, Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as Const from '../../utils/Const';

interface SumarryTableListProps {
  summaryTableListData: SummaryTableList[];
  summaryItemId: number;
}

export const SumarryTableList: React.FC<SumarryTableListProps> = ({
  summaryTableListData,
  summaryItemId,
}) => {
  const columns = GetColumns(summaryItemId);

  const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
    showColumnHeaders: true,
    filename: 'summary_table_list.csv',
  });

  const handleExportRows = (rows: MRT_Row<SummaryTableList>[]) => {
    const rowData = rows.map((row) => ({
      ...row.original,
      // Date型を文字列に変換
      start_datetime_utc:
        row.original.start_datetime_utc instanceof Date
          ? row.original.start_datetime_utc.toISOString()
          : row.original.start_datetime_utc,
      end_datetime_utc:
        row.original.end_datetime_utc instanceof Date
          ? row.original.end_datetime_utc.toISOString()
          : row.original.end_datetime_utc,
    }));
    // const csv = generateCsv(csvConfig)(rowData);
    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  const table = useMaterialReactTable<SummaryTableList>({
    columns: columns,
    data: summaryTableListData,
    createDisplayMode: 'modal',
    editDisplayMode: 'modal',
    enableStickyHeader: true,
    layoutMode: 'grid',
    enableColumnResizing: true,
    enableColumnOrdering: true,
    enableFacetedValues: true,
    // muiTableContainerProps: {
    //   sx: {
    //     minHeight: '500px',
    //     maxHeight: 'calc(100vh - 360px)', // テーブルの最大高さを設定
    //   },
    // },
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: 'flex',
          gap: '16px',
          padding: '8px',
          flexWrap: 'wrap',
        }}
      >
        <Button
          disabled={table.getPrePaginationRowModel().rows.length === 0}
          //export all rows, including from the next page, (still respects filtering and sorting)
          onClick={() => handleExportRows(table.getPrePaginationRowModel().rows)}
          startIcon={<FileDownloadIcon />}
        >
          {Const.LabelCsvExportLink}
        </Button>
      </Box>
    ),
  });

  return <MaterialReactTable table={table} />;
};

export default SumarryTableList;
